'use client';

import { selectedCustomSlotAtom, selectedZonesAtom, surveyAtom } from '@/atom/survey';
import { useAtom } from 'jotai';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { insertSurveyEntryPoint } from '@/utils/actions';
import ChatBotIconImage from '@/images/chatbot_icon.png';
import Image from 'next/image';
import './survey-start-bottom-button.css';

export default function SurveyStartBottomButton() {
  const router = useRouter();
  const [, setSurvey] = useAtom(surveyAtom);
  const [, setSelectedZones] = useAtom(selectedZonesAtom);
  const [, setSelectedCustomSlot] = useAtom(selectedCustomSlotAtom);
  const pathname = usePathname();

  const resetSurveyState = () => {
    window.sessionStorage.removeItem('preparedZoneFromTravelCard');
    window.sessionStorage.removeItem('preparedPoiIdForSurvey');
    window.sessionStorage.removeItem('allthattravel_survey');
    setSurvey({
      fromDateTime: undefined,
      toDateTime: undefined,
      companion: undefined,
      zones: [],
      customSlots: [],
      departurePoint: undefined,
    });
    setSelectedZones({ zones: [], details: [] });
    setSelectedCustomSlot([]);
  };

  const handleDirectClick = () => {
    let entryPoint = 'MAIN';
    if (pathname.includes('savedPois')) {
      entryPoint = 'MAIN-SAVEDPOIS';
    } else if (pathname.includes('myTravels')) {
      entryPoint = 'MAIN-MYTRAVELS';
    }
    insertSurveyEntryPoint(entryPoint);
    resetSurveyState();
  };

  const handleAiClick = () => {
    let entryPoint = 'MAIN-AI';
    if (pathname.includes('savedPois')) {
      entryPoint = 'MAIN-SAVEDPOIS-AI';
    } else if (pathname.includes('myTravels')) {
      entryPoint = 'MAIN-MYTRAVELS-AI';
    }
    insertSurveyEntryPoint(entryPoint);
    resetSurveyState();
    router.push('/ai-planner');
  };

  return (
    <div className='max-w-480pxr w-full fixed bottom-0 z-[2] bg-white h-100pxr px-20pxr pt-16pxr pb-32pxr'>
      <div className='flex gap-12pxr'>
        {/* AI 플래너 버튼 */}
        <button
          onClick={handleAiClick}
          className='ai-planner-button relative flex flex-row items-center justify-center gap-8pxr px-16pxr py-14pxr h-50pxr rounded-8pxr bg-white'
        >
          <span className='w-22pxr h-22pxr overflow-hidden'>
            <Image src={ChatBotIconImage} alt='chatbot icon' width={22} height={22} />
          </span>
          <span className='text-new-point-500 body-16-md'>AI 플래너</span>
        </button>

        {/* 직접 만들기 버튼 */}
        <Link href='/survey/when' scroll={false} prefetch={false} onClick={handleDirectClick} className='flex-1'>
          <div className='w-full bg-new-point-500 rounded-8pxr text-center text-white body-16-md flex justify-center items-center h-50pxr'>
            새 일정표 만들기
          </div>
        </Link>
      </div>
    </div>
  );
}
